import React, { useState } from "react";
import axios from "axios";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
function AddDevicesModal({ onClose, onDeviceAdded }) {
  const [formData, setFormData] = useState({ name: "", device_id: "", icon: null, type: "pump", status: "" });
  const [message, setMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarType, setSnackbarType] = useState("success");

  const handleChange = (event) => {
    const { name, value, files } = event.target;
    if (name === "icon") {
      setFormData((prev) => ({ ...prev, icon: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { name, device_id, icon, type, status } = formData;
    if (!name || !device_id || !status || !type) {
      setMessage("Please fill in all required fields.");
      setSnackbarType("error");
      setSnackbarOpen(true);
      return;
    }

    try {
      const data = new FormData();
      data.append("name", name);
      data.append("device_id", device_id);
      data.append("status", status);
      data.append("type", type);
      if (icon) data.append("icon", icon);

      const token = localStorage.getItem("access_token");
      if (!token) {
        setMessage("Access token not found. Please log in again.");
        setSnackbarType("error");
        setSnackbarOpen(true);
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/add-devices`,
        data,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success === false) {
        setMessage(response.data.message);
        setSnackbarType("error");
        setSnackbarOpen(true);
        return;
      }

      setMessage("Device added successfully!");
      setSnackbarType("success");
      setSnackbarOpen(true);
      setFormData({ name: "", device_id: "", icon: null, type: "pump", status: "" });

      setTimeout(() => {
        setMessage("");
        setSnackbarOpen(false);
        onDeviceAdded();
        onClose();
      }, 1000);
    } catch (error) {
      console.error("Error adding device:", error);
      setMessage(error.response?.data?.message || "Failed to add device. Please try again.");
      setSnackbarType("error");
      setSnackbarOpen(true);
    }

  };
  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  return (
    <MDBox p={3}>
      <MDTypography variant="h5" fontWeight="medium" mb={3}>Add New Device</MDTypography>
      <MDBox component="form" role="form" onSubmit={handleSubmit}>
        <div onClick={onClose} style={{ position: "absolute", top: 10, right: 10, cursor: "pointer", fontSize: 20 }}>
          &times;
        </div>
        <MDBox mb={2}><MDInput label="Name" name="name" fullWidth value={formData.name} onChange={handleChange} /></MDBox>
        <MDBox mb={2}><MDInput label="Device ID" name="device_id" fullWidth value={formData.device_id} onChange={handleChange} /></MDBox>
        <MDBox mb={2}>
          <MDTypography variant="button" mb={1}>Icon (optional)</MDTypography>
          <input type="file" name="icon" accept="image/*" onChange={handleChange} style={{ display: "block", width: "100%" }} />
        </MDBox>
        <MDBox mb={2}>
          <MDTypography variant="button" mb={1}>Type</MDTypography>
          <select
            name="type"
            value={formData.type}
            onChange={handleChange}
            style={{ width: "100%", padding: 10 }} >
            <option value="">Select type</option>
            <option value="pump">Pump</option>
            <option value="light">Light</option>
            <option value="fan">Fan</option>
          </select>
        </MDBox>

        <MDBox mb={2}>
          <MDTypography variant="button" mb={1}>Status</MDTypography>
          <select name="status" value={formData.status} onChange={handleChange} style={{ width: "100%", padding: 10 }}>
            <option value="">Select status</option>
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
        </MDBox>

        <MDBox mt={4} mb={1}><MDButton variant="gradient" color="info" type="submit" fullWidth>Add Device</MDButton></MDBox>
      </MDBox>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarType}
          sx={{ width: "100%" }}
        >
          {message}
        </MuiAlert>
      </Snackbar>
    </MDBox>
  );
}

export default AddDevicesModal;